import { Alert, Button, Result } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import ActionModalShell from './ActionModalShell';

export type ActionFeedbackKind = 'error' | 'info' | 'success' | 'warning';

interface ActionFeedbackModalProps {
  actionLabel?: string;
  kind: ActionFeedbackKind;
  message: string;
  onAction?: () => void;
  onClose: () => void;
  open: boolean;
  title: string;
}

const statusByKind = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning',
} as const;

const iconByKind = {
  error: <CloseCircleOutlined />,
  info: <InfoCircleOutlined />,
  success: <CheckCircleOutlined />,
  warning: <WarningOutlined />,
};

export const ActionFeedbackModal = ({ actionLabel, kind, message, onAction, onClose, open, title }: ActionFeedbackModalProps) => {
  const { t } = useTranslation();
  return (
    <ActionModalShell
      footer={<div className="dms-action-modal__footer">{onAction && actionLabel ? <Button type="primary" onClick={onAction}>{actionLabel}</Button> : null}<Button onClick={onClose}>{t('actionsModal.close')}</Button></div>}
      onCancel={onClose}
      open={open}
      title={title}
      width={500}
    >
      <Result icon={iconByKind[kind]} status={statusByKind[kind]} title={title} subTitle={message} />
    </ActionModalShell>
  );
};

export const ActionInlineError = ({ message }: { message: string | null }) =>
  message ? <Alert type="error" showIcon role="alert" message={message} /> : null;
